import axios from "axios";

/**
 * Service API pour la gestion de l'historisation des KPI
 */
export default {
  /**
   * Récupère la liste des périodes pour lesquelles des snapshots existent
   * @returns {Promise} Liste des périodes historisées
   */
  getHistorizedPeriods() {
    return axios.get("/api/kpi/history/periods");
  },

  /**
   * Génère un snapshot mensuel pour une période donnée
   * @param {number} year - L'année
   * @param {number} month - Le mois (1-12)
   * @returns {Promise} Résultat de la génération
   */
  generateMonthlySnapshot(year, month) {
    return axios.post("/api/kpi/history/generate/monthly", {
      year,
      month,
    });
  },

  /**
   * Génère un snapshot annuel pour une année donnée
   * @param {number} year - L'année
   * @returns {Promise} Résultat de la génération
   */
  generateAnnualSnapshot(year) {
    return axios.post("/api/kpi/history/generate/annual", {
      year,
    });
  },

  /**
   * Génère l'historique rétroactif entre deux périodes
   * @param {number} startYear - Année de début
   * @param {number} startMonth - Mois de début (1-12)
   * @param {number} endYear - Année de fin
   * @param {number} endMonth - Mois de fin (1-12)
   * @returns {Promise} Résultat de la génération
   */
  generateRetroactiveHistory(startYear, startMonth, endYear, endMonth) {
    return axios.post("/api/kpi/history/generate/retroactive", {
      startYear,
      startMonth,
      endYear,
      endMonth,
    });
  },

  /**
   * Supprime un snapshot pour une période donnée
   * @param {number} year - L'année
   * @param {number|null} month - Le mois (optionnel, null pour snapshot annuel)
   * @returns {Promise} Résultat de la suppression
   */
  deleteSnapshot(year, month = null) {
    const url = month
      ? `/api/kpi/history/${year}/${month}`
      : `/api/kpi/history/${year}`;
    return axios.delete(url);
  },

  /**
   * Valide l'intégrité des snapshots pour une période donnée
   * @param {number} year - L'année
   * @param {number|null} month - Le mois (optionnel, null pour snapshot annuel)
   * @returns {Promise} Résultat de la validation
   */
  validateSnapshot(year, month = null) {
    const url = month
      ? `/api/kpi/history/validate/${year}/${month}`
      : `/api/kpi/history/validate/${year}`;
    return axios.get(url);
  },
};
